import type { CellContext } from '@tanstack/react-table';
import type { DataGridColumnDef, DataGridColumnDefOptions } from '../../data-grid.type';
import { Tag } from '@components/atoms';
import type { TAllowedColors } from '@components/atoms/tag/types';

export function getColumnDefTag<T>(col: DataGridColumnDef<T>, options: DataGridColumnDefOptions) {
	return function TagCell(context: CellContext<T, unknown>) {
		let value = context.getValue();
		const row = context.row.original;
		let color = 'green';
		let secondaryContent: string | undefined;

		if (options?.parse) {
			const parsed = options.parse(value, row, options);
			value = parsed.value;
			color = parsed.color || color;
			secondaryContent = parsed.secondaryContent;
		}

		if (!secondaryContent) {
			return <Tag color={color as TAllowedColors}>{String(value)}</Tag>;
		}

		return (
			<div className="flex w-full min-w-0 flex-col items-start gap-0.5">
				<Tag color={color as TAllowedColors}>{String(value)}</Tag>
				<div className="w-full truncate text-xs text-secondary">{secondaryContent}</div>
			</div>
		);
	};
}
